<div [class.block]="widgetConfig?.type === 'horizontalBar'" class="chart-widget">
  <canvas [id]="widgetConfig?.id"></canvas>
</div>
